
  <div class="{{ inline ? 'd-inline' : 'row' }}">
      <div class="{{ inline ? 'd-inline' : 'col-12 col-md-6 col-lg-4 col-xl-2 col-xxl-1' }}">
          <a (click)="downloadPDFReport()" class="btn btn-link text-primary {{ inline ? 'py-0 btn-sm' : ''}}">
              <i class="fa {{isReportInProcess ? 'fa-circle-o-notch fa-spin' : 'fa-download'}}"></i>&nbsp;Download PDF Report
          </a>
      </div>
  </div>
  